import React, { useEffect, useState } from 'react';
import {
  Modal,
  View,
  Text,
  TouchableOpacity,
  Platform,
  Linking,
} from 'react-native';
import { useSelector } from 'react-redux';
import styled from 'styled-components/native';
import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { updateCheckProperties } from '../config.js';
import Bugsnag from '@bugsnag/expo';

function ForceUpdateHandler() {
  const [forceUpdate, setForceUpdate] = useState(false);
  const { appActive } = useSelector((state) => state.pvtFocusState);
  const {
    versionInt,
    updateVersionCheckURL,
    playStoreLink,
    iTunesStoreLink,
    updateCheckRedirectFile,
    updateCheckFile,
    updateCheckWaitHours,
  } = updateCheckProperties;

  useEffect(() => {
    async function checkForRequiredUpdate() {
      try {
        // check to see if the file containing the version check has moved
        let currentUpdateCheckURL = await AsyncStorage.getItem(
          'updateCheckURL'
        );
        console.log('Current Update Check Domain', currentUpdateCheckURL);
        if (null === currentUpdateCheckURL) {
          // set to the url stored in the app config
          currentUpdateCheckURL = updateVersionCheckURL;
          await AsyncStorage.setItem('updateCheckURL', updateVersionCheckURL);
        }
        console.log(`${currentUpdateCheckURL}/${updateCheckRedirectFile}`);
        const fileLocationRedirect = await axios.get(
          `${currentUpdateCheckURL}/${updateCheckRedirectFile}`
        );
        console.log('File Location Redirect Value', fileLocationRedirect.data);
        if (Object.keys(fileLocationRedirect.data).length > 0) {
          // the domain where the version check file is located has changed
          currentUpdateCheckURL = fileLocationRedirect.data.newDomain;
          await AsyncStorage.setItem('updateCheckURL', currentUpdateCheckURL);
        }

        // check the file to see if the minimum version is still installed
        const minimumVersionCheck = await axios.get(
          `${currentUpdateCheckURL}/${updateCheckFile}`
        );
        console.log('Minimum Version Required', minimumVersionCheck.data);
        if (
          parseInt(minimumVersionCheck.data.minimumRequiredVersion) > versionInt
        ) {
          // force update the app if the minimum version is not installed
          setForceUpdate(true);
        }
      } catch (e) {
        Bugsnag.leaveBreadcrumb('Force Update Handler Error Caught');
        Bugsnag.notify(e);
      }
    }
    console.log('Update Handler App Active Watch: ', appActive);
    if (appActive) {
      checkForRequiredUpdate();
    }
  }, [appActive]);

  const updateAction = () => {
    // Redirect Android store
    if ('android' === Platform.OS) {
      Linking.canOpenURL(playStoreLink)
        .then(() => {
          Linking.openURL(playStoreLink);
        })
        .catch();
      // Redirect Apple store
    } else if ('ios' === Platform.OS) {
      Linking.canOpenURL(iTunesStoreLink)
        .then(() => Linking.openURL(iTunesStoreLink))
        .catch();
    }
    setForceUpdate(false);
  };

  return (
    <>
      {forceUpdate && (
        <Modal animationType='fade' transparent={true}>
          <ModalWrapper>
            <ModalTextWrapper>
              <ModalText>
                There is a new version available. Please update to continue
                using the app.
              </ModalText>
              <SubmitButton onPress={() => updateAction()}>
                <ButtonText>UPDATE NOW</ButtonText>
              </SubmitButton>
            </ModalTextWrapper>
          </ModalWrapper>
        </Modal>
      )}
    </>
  );
}

const ModalWrapper = styled.View`
  flex: 1;
  justify-content: center;
  background: rgba(40, 47, 99, 0.9);
`;

const ModalTextWrapper = styled.View`
  align-items: center;
`;

const ButtonText = styled.Text`
  align-self: center;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  padding-top: 15px;
  padding-bottom: 15px;
`;

const SubmitButton = styled.TouchableOpacity`
  background: #3366cc;
  border-radius: 50px;
  width: 270px;
`;

const ModalText = styled.Text`
  color: #fff;
  font-family: 'Montserrat-EB';
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  padding-bottom: 50px;
  padding-left: 30px;
  padding-right: 30px;
`;

export default ForceUpdateHandler;
